import React from 'react';
import { Link } from 'react-router-dom';

import placeholderImage from '../../../images/logo_placeholder.png';
import { handleImageError } from '../../base/common/utils';
import { session } from '../../../services/session';

import './styles/retailer-overview-row.scss';

const performanceMap = {
  publisher_total_earnings: 'Earnings',
  clicks: 'Clicks',
  publisher_epc: 'EPC',
};

const RetailerOverviewRow = ({ retailer }) => {
  // New Partner Badge
  const newPartner = retailer.is_new ? <label className="new-retailer">New Partner</label> : null;

  // Active Status
  const activeStatus = retailer.is_in_network ? 'active' : 'inactive';

  const rateVerbiage =
    retailer.strategies && retailer.strategies.num_strategies > 1
      ? ''
      : 'One strategy available at ';
  const otherStrategiesVerbiage =
    retailer.strategies && retailer.strategies.num_strategies > 1
      ? `+${retailer.strategies.num_strategies - 1} other strategies`
      : '';

  // Strategies
  const strategies = retailer.strategic_rate ? (
    <>
      {rateVerbiage}
      <span className="rate">{retailer.strategic_rate}</span>
      <span>{otherStrategiesVerbiage}</span>
    </>
  ) : (
    <span>-</span>
  );

  // Your Performance
  const performance = parseFloat(retailer.clicks) ? (
    Object.keys(performanceMap).map((key, idx) => {
      const subText = <span>Your {performanceMap[key]}</span>;
      return (
        <div key={idx} className={key}>
          <span>{retailer[key]}</span>
          {subText}
        </div>
      );
    })
  ) : (
    <div className="no-stats">No recommendations for this partner</div>
  );

  const activeContainer = (
    <div className="active-container">
      <span className={`active-status ${activeStatus}`} />
      <span className={activeStatus}>{activeStatus}</span>
    </div>
  );

  return (
    <Link
      className={`row partners-row ${activeStatus}`}
      to={`/v2/publisher/${session.orgId}/new-recs/rates/${retailer.merch_id}`}
    >
      {/* Retailer */}
      <div className="column retailer-rates-strategies">
        {newPartner}
        <div className="logo">
          <img
            src={retailer.logo_url || placeholderImage}
            alt={`${retailer.merchant_name || 'retailer'} logo`}
            onError={e => handleImageError(e, placeholderImage)}
          />
        </div>

        <div className="retailer-name">
          <span>{retailer.merchant_name}</span>
          {activeContainer}
        </div>

        <div className="baseline-rate">
          <span className="rate">{retailer.commission_rate}</span>
          <span>{retailer.payment_model}</span>
        </div>

        <div className="strategies">{strategies}</div>
      </div>

      {/* Your Performance */}
      <div className={`column performance ${activeStatus}`}>{performance}</div>
    </Link>
  );
};

export default RetailerOverviewRow;
